
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
	name: 'Breadcrumbs'
})
export default class Breadcrumbs extends Vue {
	@Prop({ type: Array }) readonly crumbs!: { name: string; url: string }[];

	@Prop({ type: Boolean }) readonly isCompanyPage?: boolean;

	getLinkClasses(index: number): string[] {
		const linkClasses: string[] = [];
		if (this.isCompanyPage) {
			linkClasses.push('hover:text-color-main-business-hover');
		} else {
			linkClasses.push('hover:text-color-main-hover');
		}
		if (index === this.crumbs.length - 1) {
			if (this.isCompanyPage) {
				linkClasses.push('text-color-main-business');
			} else {
				linkClasses.push('text-color-main');
			}
		} else {
			linkClasses.push('text-color-text');
		}
		return linkClasses;
	}
}
